<template>
<div class="all-container">
    <el-container>
        <div class="aside-content" id="aside-content" style="background-color: #000;height:100%;">
            <div class="logo-style">
                <img src="../assets/images/deloitte.svg" alt="Deloitte">
            </div>
            <div class="left-nav-content" style="height:calc(100% - 50px);overflow-y:scroll;">
                <div class="first-li" id="left-nav-content">
                    <router-link to="/index" class="hdp-uf hdp-uf-vc">
                        <img src="../assets/images/icon01.png">
                        <span :class="$t('m.LapModuleStyle')">{{$t("m.LapModule")}}</span>
                    </router-link>
                </div>
                <div class="">
                    <el-collapse accordion>
                        <el-collapse-item v-for="(item, index) in menuList" :key="index">
                            <template slot="title">
                                <div class="hdp-uf hdp-uf-vc">
                                  <img :src="'./static/images/' + item.menuIcon" />
                                  <span class="psc-font-3">{{$t('m.' + item.menuCode)}}</span>
                                </div>
                            </template>
                            <ul class="nav02">
                                <li v-for="(item2, index2) in item.childrenList" :key="index2" class="nav02-li">
                                    <router-link :to="item2.menuLink" class="hdp-ut-s psc-font-4">
                                       {{$t('m.' + item2.menuCode)}}
                                    </router-link>
                                </li>
                            </ul>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
        <el-container>
            <el-header>
                <div style="margin-top: 5px"><lap-change-lang></lap-change-lang></div>
                <div class="user-info">
                    <img src="../assets/images/avatar.png" />
                    <span class="user-name" slot="reference"> {{userName}} </span>
                </div>
                <div class="logout" @click="logout()"><i class="icon-logout"></i>{{$t("m.exit")}}</div>
            </el-header>
            <el-main>
                <router-view :style="{'width': contentWidth + 'px'}">
                </router-view>
            </el-main>
        </el-container>
    </el-container>
</div>
</template>
<script>
import dynamicRouter from '@/router/dynamic-router'
import router, { DynamicRoutes } from '@/router/index'
import PageIndex from '@/pages/PageIndex'
import Index from '@/pages/Index'
export default {
    name: 'PageIndex',
    data () {
        return {
            userName: '',
            menuList: [],
            contentWidth: ''
        }
    },
    methods: {
        logout () {
            this.$confirm(this.$t('m.sureExit'), this.$t('m.tips'), {
                    confirmButtonText: this.$t('m.sure'),
                    cancelButtonText: this.$t('m.cancel'),
                    type: 'warning'
                })
                .then(() => {
                    this.$commonFunc.commonRequest('get', '/system/user/logout')
                        .then(res => {
                            this.$store.dispatch('userInfo/doClearUserInfo')
                            this.$router.push('/');
                            // localStorage.clear()
                            window.location.reload()
                        })
                        .catch(res => {
                            this.$store.dispatch('userInfo/doClearUserInfo')
                            this.$router.push('/');
                            // localStorage.clear()
                            window.location.reload()
                        })
                })
        },
        cumContentWidth() {
            let dom = document.getElementById('aside-content')
            if(dom) {
                this.contentWidth = document.body.clientWidth - dom.clientWidth - 80
            }
            
        }
    },
    mounted() {
        this.userName =  this.$store.state.userInfo.userInfoObj.userName
        //权限菜单
        let authorityList = this.$store.state.userInfo.userInfoObj.authorityList
        this.menuList = authorityList
        console.log(this.menuList)
        //权限路由
        let matchRouter = this.$commonFunc.recursionRouter(this.menuList, dynamicRouter)
        let routers = [{
            path: '/index',
            name: 'PageIndex',
            component: PageIndex,
            meta: {
              requireAuth: true
            },
            children: [
                {
                    path: '/index',
                    name: 'Index',
                    component: Index
                }]
        }]
        routers[0].children.push(...matchRouter)
        this.$router.addRoutes(routers)
        this.$nextTick(()=>{
            this.cumContentWidth()
        })
        window.onresize = () => {
            this.cumContentWidth()
        }
    }
}
</script>
<style lang="scss" scoped>
.all-container {
    height: 100%;
    .el-container {
        height: 100%;
        .el-header {
            background: #000;
            color: #fff;
            display: flex;
            justify-content: flex-end;
            height: 50px !important;
            line-height: 50px;
            .user-info {
                margin-left: 48px;
                margin-right: 48px;
                font-size: 14px;
                img {
                    height: 36px;
                    /*margin-top: -7px;*/
                    vertical-align: middle;
                }
                /*
                .user-name {
                    cursor: pointer;
                }
                */
            }
            .logout {
                cursor: pointer;
                margin-right: 48px;
                font-size: 14px;
                .icon-logout {
                    margin-right: 8px;
                    cursor: pointer;
                }
            }
        }
        .el-main {
            width: 100%;
            padding: 0 32px 32px;
        }
        .aside-content {
            background: #000;
            width: 15%;
            min-width: 250px;
            .logo-style {
                height: 50px;
                img {
                    height: 18px;
                    margin-top: 16px;
                    margin-left: 18px;
                }
            }
            .left-nav-content {
                a {
                    text-decoration: none;
                    color: inherit;
                }
                width: 100%;
                list-style: none;
                color: #97999b;
                .first-li {
                    height: 150px;
                    line-height: 150px;
                    // font-size: 24px;
                    color: #409EFF;
                    img {
                        margin-left: 24px;
                        margin-right: 16px;
                    }
                    span {
                        // font-size: 24px;
                    }
                }
                .el-collapse {
                    border: none;
                }
                /deep/ .el-collapse-item {
                    .el-collapse-item__header {
                        height: 60px;
                        line-height: 60px;
                        color: #97999B;
                        background-color: inherit;
                        border-bottom: none;
                        font-size: 18px;
                        img {
                            margin-left: 24px;
                            margin-right: 16px;
                        }
                        i {
                            line-height: 60px;
                            &.el-collapse-item__arrow {
                                margin-right: 24px;
                            }
                        }
                        &.is-active {
                            background: #1E1F21;
                        }
                    }
                    .el-collapse-item__wrap {
                        border-bottom: none;
                        background: #1E1F21;
                        .el-collapse-item__content {
                            padding-bottom: 0;
                            .nav02 > li {
                                height: 60px;
                                line-height: 60px;
                                border-top: 1px solid #0A1019;
                                color: #97999B;
                                font-size: 18px;
                                a {
                                    display: block;
                                    height: 60px;
                                    padding-left: 60px;
                                    &.router-link-active {
                                        background: #0A1019;
                                        color: #ffffff
                                    }
                                }
                                &.active-li02 {
                                    background: #0A1019;
                                    color: #ffffff;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageIndex.vue